import React, { lazy } from 'react';
import { RouteConfig } from 'react-router-config';
import IconDropframe from '@/assets/images/menu/icon-dropframe.react.svg?react';
import { isHarmonyOS } from '@/infrastructure/product-info';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';

export const dropFrameRoutes = (): RouteConfig[] => [
  {
    path: '/drop-frame',
    name: '卡顿',
    icon: <MenuIcon icon={IconDropframe} />,
    sort: 94,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.Mac,
      CapitalPlatform.Windows,
      CapitalPlatform.VisionOS,
      CapitalPlatform.Flutter,
      CapitalPlatform.HarmonyOS,
    ],
    routes: [
      {
        path: '/drop-frame/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/drop-frame/analytics')),
      },
      {
        path: '/drop-frame/analytics-old',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/drop-frame/analytics')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/drop-frame/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/drop-frame/issues/list')),
      },
      {
        path: '/drop-frame/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/drop-frame/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/drop-frame/tree',
        name: '卡顿树',
        hideInMenu: isHarmonyOS(),
        component: lazy(() => import('@/presentation/pages/drop-frame/tree')),
        platforms: [
          CapitalPlatform.Android,
          CapitalPlatform.IOS,
          CapitalPlatform.Mac,
          CapitalPlatform.Windows,
          CapitalPlatform.VisionOS,
          CapitalPlatform.Flutter,
        ],
      },
      {
        path: '/drop-frame/task-detail',
        name: '离线任务详情',
        component: lazy(() => import('@/presentation/pages/drop-frame/tree/task-detail')),
        hideInMenu: true,
      },
    ],
  },
];

export default dropFrameRoutes;
